import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCableEditStore = defineStore('cableEdit', () => {
    const cableCode = ref<string | null>(null);
    const cableSpec = ref<string | null>(null);

    function setCableCode(value: string | null) {
        cableCode.value = value;
    }

    function setCableSpec(value: string | null) {
        cableSpec.value = value;
    }

    function popCableCode() {
        const val = cableCode.value;
        cableCode.value = null;
        return val;
    }

    function popCableSpec() {
        const val = cableSpec.value;
        cableSpec.value = null;
        return val;
    }

    return {
        cableCode,
        cableSpec,
        setCableCode,
        setCableSpec,
        popCableCode,
        popCableSpec
    };
});
